import React from "react";
import PolicyIcon from "@mui/icons-material/Policy";
import DownloadIcon from "@mui/icons-material/Download";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { SelectInput, TextInput, required, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import { getFileFromUrl, previewFileFromUrl } from "server/components/DownloadFile";
import { DocumentAction } from "utils/constants";

const ACTIONS = {
  [DocumentAction.Preview]: { saveTitle: "Виж", saveIcon: <PolicyIcon />, request: previewFileFromUrl },
  [DocumentAction.Download]: { saveTitle: "Изтегли", saveIcon: <DownloadIcon />, request: getFileFromUrl },
};

// Keeps only the declared macro keys and drops optional fields the user left blank, so the BE receives
// a flat string -> string map of typed values. It also strips anything react-admin seeds into the form
// from the surrounding RecordContext (the declaration row).
const toMacros = (values, macros) =>
  Object.fromEntries(
    macros
      .map(macro => [macro.key, values?.[macro.key]])
      .map(([key, value]) => [key, typeof value === "string" ? value.trim() : value])
      .filter(([, value]) => typeof value === "string" && value !== ""),
  );

// Asks the user for the macros the BE cannot prefill for a declaration (customMacros from
// GET .../declarations), then previews or downloads the document with them in the POST body.
// `triggerButton` opens it; `action` (DocumentAction) is what its submit does.
const DeclarationMacrosModal = ({ action, macros, url, triggerButton }) => {
  const notify = useNotify();
  const { saveTitle, saveIcon, request } = ACTIONS[action];

  // DownloadFile helpers notify on failure themselves.
  const handleSubmit = values => request(url, null, notify, "POST", { macros: toMacros(values, macros) });

  return (
    <FormModal
      triggerButton={triggerButton}
      titleContent="Данни за документа"
      titleIcon={<EditNoteIcon />}
      subtitle="Попълнете данните, които не се попълват автоматично"
      onConfirm={handleSubmit}
      saveTitle={saveTitle}
      saveIcon={saveIcon}
    >
      {/* A macro with options is a dropdown (e.g. the signer of a certificate); the BE accepts only the
          listed option values, everything else is free text. */}
      {macros.map(macro =>
        macro.options?.length ? (
          <SelectInput
            key={macro.key}
            source={macro.key}
            label={macro.isRequired ? macro.name : `${macro.name} (по желание)`}
            choices={macro.options}
            optionValue="value"
            optionText="label"
            validate={macro.isRequired ? required("Задължително") : undefined}
            fullWidth
          />
        ) : (
          <TextInput
            key={macro.key}
            source={macro.key}
            label={macro.isRequired ? macro.name : `${macro.name} (по желание)`}
            validate={macro.isRequired ? required("Задължително") : undefined}
            fullWidth
          />
        ),
      )}
    </FormModal>
  );
};

export default DeclarationMacrosModal;
